/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XIcon16Solid = forwardRef('XIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.94 2.94a1.5 1.5 0 0 1 2.12 0L8 5.878l2.94-2.94a1.5 1.5 0 1 1 2.12 2.122L10.122 8l2.94 2.94a1.5 1.5 0 1 1-2.122 2.12L8 10.122l-2.94 2.94a1.5 1.5 0 1 1-2.12-2.122L5.878 8l-2.94-2.94a1.5 1.5 0 0 1 0-2.12Z" })));
});
